/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Form, Errors, Control, actions } from 'react-redux-form';
import { find } from 'lodash';
import SearchableSelect from '../../../components/common/form/elements/searchable-select';
import ArrowButton from '../../../components/common/button-arrow';
import RequiredInput from '../../../components/common/form/elements/required-input';
import FileUpload from '../../../components/common/form/elements/file-upload';
import FileUploadFileList from '../../../components/common/form/elements/file-upload-file-list';
import { getSellItObjectives, getNgpObjectives } from "../../../actions/submissions";

class TeamSubmissionForm extends Component {
  state = {
    label: 'Unique identifier',
    stores: []
  };

  componentWillReceiveProps(nextProps) {
    const { meta } = nextProps;

    if (this.state.stores.length === 0) {
      this.setState({
        stores: meta.stores
      });
    }
  }

  componentWillMount() {
    this.setState({ stores: this.props.meta.stores });
  }

  handleOutletChange = (e) => {
    const { isNgp, dispatch } = this.props;

    if (isNgp) {
      dispatch(getNgpObjectives(e));
    } else {
      dispatch(getSellItObjectives(e));
    }
  };

  handleIncentiveChange = (e) => {
    const { isNgp } = this.props;

    if (isNgp) {
      const ngpObjective = find(this.props.meta.ngp_objectives, { value: e });

      this.setState({ stores: ngpObjective.outlets });
    } else {
      const sellItObjective = find(this.props.meta.sell_it_objectives, { value: e });

      this.setState({ stores: sellItObjective.outlets });
    }
  };

  handleProofChange = (e) => {
    switch(e) {
    case "EPOS data":
      this.setState({ label: "Extract Dates" });
      break;
    case "Cash & Carry receipt":
      this.setState({ label: "Invoice number" });
      break;
    case "Damaged barcodes":
      this.setState({ label: "Photograph of damaged barcodes" });
      break;
    default:
      this.setState({ label: "Unique identifier" });
    }
  };

  removeFile(id, file) {
    const index = this.props.formData.proof_of_purchases_attributes.map(object => Object.keys(object)[0]).indexOf(id);

    if (file.persisted !== false) {
      this.props.dispatch(actions.push(`deep.submission.proof_of_purchases_attributes`, { [id]: {id: file.id, _destroy: true } }));
    } else {
      this.props.dispatch(actions.remove(`deep.submission.proof_of_purchases_attributes`, index));
    }
  }

  render() {
    const {
      formData, formValid, model, onSubmit, meta, isNgp
    } = this.props;

    const proofOfPurchaseOptions = [
      { value: meta.proof_types[0], label: meta.proof_types[0]},
      { value: meta.proof_types[1], label: meta.proof_types[1]}
    ];

    if (!isNgp) {
      proofOfPurchaseOptions.push({ value: meta.proof_types[2], label: meta.proof_types[2]});
    }

    const objectiveSelectLabel = isNgp ? 'Blu Bar Sell It Objective' : 'Sell it Objective';
    const objectives = isNgp ? meta.ngp_objectives : meta.sell_it_objectives;

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid padding-flush">
          <Form model={model} onSubmit={onSubmit} className="sell-it-submissions-tabs-epos-form">
            {isNgp && meta.ngp_objectives && meta.ngp_objectives.length === 0 && (
              <div className='no_blu_bar'>
                No current blu bar objective available
              </div>
            )}
            <Row>
              <Col md={6} xs={12}>
                <Row>
                  <Col md={12}>
                    <Errors model={model} className="errors" />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Outlet Name'
                      model='deep.submission.outlet_id'
                      options={this.state.stores}
                      value={formData.outlet_id}
                      onChange={this.handleOutletChange}
                      required
                    />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label={objectiveSelectLabel}
                      model='deep.submission.incentive_id'
                      options={objectives}
                      value={formData.incentive_id}
                      onChange={this.handleIncentiveChange}
                      required
                    />
                  </Col>
                  <Col md={12}>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip id='tooltip'>
                          Please ensure you provide the number of outers that you have purchased and not the number of packs you have purchased
                    </Tooltip>}
                    >
                      <Glyphicon
                        glyph="question-sign"
                        style={{ color: '#ab1738', cursor: 'pointer', fontSize: '30px', float: 'right', paddingBottom: '5px' }}
                      />
                    </OverlayTrigger>
                    <RequiredInput
                      label="Number of outers purchased"
                      model=".number_of_outers"
                    />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Wholesaler'
                      model='deep.submission.wholesaler_id'
                      options={meta.wholesalers}
                      value={formData.wholesaler_id}
                      required={!isNgp}
                    />
                  </Col>
                  <Col md={12}>
                    <SearchableSelect
                      label='Proof of purchase type'
                      model='deep.submission.proof_type'
                      options={proofOfPurchaseOptions}
                      value={formData.proof_type}
                      onChange={this.handleProofChange}
                      required
                    />
                  </Col>
                  <Col md={12}>
                    <label className="file-upload-label">Proof of purchase</label>
                    <div className="file-upload-description">Please upload a copy of your proof of purchase to support your submission*</div>
                    <FileUpload
                      label=""
                      model={`.proof_of_purchases`}
                      showFileNameInTextField={false}
                      onFileLoaded={file => this.props.dispatch(actions.push('deep.submission.proof_of_purchases_attributes', { [Date.now()]: { persisted: false, proof_of_purchase: file } }))}
                      multi
                      required
                    />
                  </Col>
                  <div style={{ marginBottom: '20px' }}>
                    <FileUploadFileList
                      data={formData.proof_of_purchases_attributes}
                      model={'deep.submission.proof_of_purchases_attributes'}
                      fileName={'proof_of_purchase'}
                    />
                  </div>

                  <Col md={12}>
                    <Control.checkbox
                      model=".store_name_confirm"
                      required
                    />
                    My upload includes my store name*
                  </Col>
                      <Col md={12}>
                        <Control.checkbox
                          model=".dates_confirm"
                          required
                        />
                    My upload includes correct dates*
                  </Col>
                      <Col md={12}>
                        <Control.checkbox
                          model=".evidence_confirm"
                          required
                        />
                    I will not submit evidence by post*
                  </Col>
                  <Col md={12} className="sell-it-submissions-tabs-epos-form-buttons">
                    <ArrowButton className="pull-right" arrow={false} disabled={!formValid} submit>Submit</ArrowButton>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.submission,
  formValid: state.deep.forms.submission.$form.valid
});

export default connect(mapStateToProps)(TeamSubmissionForm);



// WEBPACK FOOTER //
// ./src/components/submissions/sell-it-uploader/submission-form.jsx